// ABOUTME: Classifies recoverable CV parser failures for applicant upload.
// ABOUTME: Builds manual-entry state while preserving the selected CV file.

export const RECOVERABLE_PARSER_FAILURES = [
    "OPENAI_INSUFFICIENT_QUOTA",
    "PARSER_ERROR"
];

export const isRecoverableParserFailure = (responseData: any) =>
    responseData?.success === false &&
    RECOVERABLE_PARSER_FAILURES.includes(responseData?.error);

export const buildManualEntryPayload = (
    file: { name: string },
    urlCV?: string
) => ({
    jsonParsedCV: undefined,
    urlCV,
    pageToRender: "dataEntry" as const,
    cvFile: { streamContent: file, fileName: file.name }
});
